import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { updateSlateErrorData } from '~/editor/error';
import { logError } from '~/utils/logError';

export const ERROR_REPORTING_PLUGIN_KEY = 'error-reporting';

const handleErrorCallback =
  (callback, editor: BufferEditor) =>
  (...args) => {
    try {
      return callback(...args);
    } catch (error) {
      logError(error, {
        beforeSend: updateSlateErrorData({ context: 'SlateError', editor }),
      });
      throw error;
    }
  };

export const withErrorReporting = (editor: BufferEditor): BufferEditor => {
  Object.entries(editor).forEach(([key, value]) => {
    if (typeof value === 'function') {
      editor[key] = handleErrorCallback(value, editor);
    }
  });

  return editor;
};
